import React, { FC } from "react";

import AdGroupCreationForm from "../components/AdGroupCreationForm";
import TabPanel from "../../../../components/elements/TabPanel";
import { PageStepComponentProps } from "../../../../components/modules/BaseStepper/BaseStepper";

type CreateNewAdGroupTabProps = {
  selectedTabPanelValue: number;
};

const CreateNewAdGroupTab: FC<PageStepComponentProps & CreateNewAdGroupTabProps> = ({
  isAttemptingToGoNext,
  setIsAttemptingToGoNext,
  handleNext,
  selectedTabPanelValue,
}) => {
  return (
    <TabPanel
      value={selectedTabPanelValue}
      index={0}
      id="adGroup-selection-tabpanel"
      ariaLabelledBy="adGroup-selection-tab"
    >
      <AdGroupCreationForm
        isAttemptingToGoNext={isAttemptingToGoNext}
        setIsAttemptingToGoNext={setIsAttemptingToGoNext}
        handleNext={handleNext}
      />
    </TabPanel>
  );
};

export default CreateNewAdGroupTab;
